import Vue from "vue";
import { getField, updateField } from "vuex-map-fields";
import {
  SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY_LEADERSHIP,
  SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY_OTHER_POSITIONS,
  SELF_ASSESSMENT_FIELDS_STAFF_BY_DEPARTMENT,
  SELF_ASSESSMENT_FIELDS_STAFF_BOARD_OF_DIRECTORS,
  SELF_ASSESSMENT_FIELDS_BY_DEMOGRAPHICS_AGE,
  SELF_ASSESSMENT_FIELDS_BY_DEMOGRAPHIC_DISABILITIES,
  SELF_ASSESSMENT_FIELDS_BY_ETHNIC_IDENTITY,
  SELF_ASSESSMENT_FIELDS_BY_ETHNIC_SENIORITY,
  SELF_ASSESSMENT_FIELDS_BY_GENDER_IDENTITY,
} from "../../../../constants/selfAssessmentStaff.constants";
import {
  SELF_ASSESSMENT_LABOR_CONDITIONS_SEXUAL_HARASSMENT_RECEIVED,
  SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION_POSITION,
  SELF_ASSESSMENT_LABOR_CONDITIONS_POSITION,
  SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION,
  SELF_ASSESSMENT_LC_TYPE_OF_CONTRACT_FULL_TIME,
  SELF_ASSESSMENT_LC_TYPE_OF_CONTRACT_PART_TIME,
  SELF_ASSESSMENT_LC_WAGES,
  SELF_ASSESSMENT_LC_WORKING_PARENTS,
  SELF_ASSESSMENT_LC_EXTENDED_LEAVE_POLICIES,
} from "../../../../constants/selfAssessmentLaborConditions.constants";
import { SELF_ASSESSMENT_GENERAL_INFORMATION } from "../../../../constants/selfAssessmentGeneralInformation.constants";
import { axiosCall } from "../../../../utils/axiosCall";
const DEFAULT_SELF_ASSESSMENT_VALUE = null;

export const SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY = [
  "selfAssessment_staff_responsibility_otherPositions_technical_women",
  "selfAssessment_staff_responsibility_otherPositions_technical_men",
  "selfAssessment_staff_responsibility_otherPositions_administrative_women",
  "selfAssessment_staff_responsibility_otherPositions_administrative_men",
  "selfAssessment_staff_responsibility_otherPositions_support_women",
  "selfAssessment_staff_responsibility_otherPositions_suport_men",
  "selfAssessment_staff_responsibility_otherPositions_operational_women",
  "selfAssessment_staff_responsibility_otherPositions_operational_men",
  "selfAssessment_staff_responsibility_otherPositions_subtotal_women",
  "selfAssessment_staff_responsibility_otherPositions_subtotal_men",
  "selfAssessment_staff_responsibility_total_women",
  "selfAssessment_staff_responsibility_total_men",
  "selfAssessment_staff_department_administration_women",
  "selfAssessment_staff_department_administration_men",
  "selfAssessment_staff_department_commercial_women",
  "selfAssessment_staff_department_commercial_men",
  "selfAssessment_staff_department_logistics_women",
  "selfAssessment_staff_department_logistics_men",
  "selfAssessment_staff_department_production_women",
  "selfAssessment_staff_department_production_men",
  "selfAssessment_staff_department_technical_women",
  "selfAssessment_staff_department_technical_men",
  "selfAssessment_staff_department_service_women",
  "selfAssessment_staff_department_service_men",
  "selfAssessment_staff_department_humanResources_women",
  "selfAssessment_staff_department_humanResources_men",
  "selfAssessment_staff_department_total_women",
  "selfAssessment_staff_department_total_men",
  "selfAssessment_staff_board_women",
  "selfAssessment_staff_board_men",
  "selfAssessment_staff_byDemographics_age_under18_women",
  "selfAssessment_staff_byDemographics_age_under18_men",
  "selfAssessment_staff_byDemographics_age_between18And30_women",
  "selfAssessment_staff_byDemographics_age_between18And30_men",
  "selfAssessment_staff_byDemographics_age_between31And60_women",
  "selfAssessment_staff_byDemographics_age_between31And60_men",
  "selfAssessment_staff_byDemographics_age_older60_women",
  "selfAssessment_staff_byDemographics_age_older60_men",
  "selfAssessment_staff_byDemographics_age_total_women",
  "selfAssessment_staff_byDemographics_age_total_men",
  "selfAssessment_staff_byDemographics_disability_total_women",
  "selfAssessment_staff_byDemographics_disability_total_men",
  "selfAssessment_staff_byDemographics_ethnicIdentity_total_women",
  "selfAssessment_staff_byDemographics_ethnicIdentity_total_men",
  "selfAssessment_staff_byDemographics_seniority_less2_women",
  "selfAssessment_staff_byDemographics_seniority_less2_men",
  "selfAssessment_staff_byDemographics_seniority_between2And5_women",
  "selfAssessment_staff_byDemographics_seniority_between2And5_men",
  "selfAssessment_staff_byDemographics_seniority_between5And10_women",
  "selfAssessment_staff_byDemographics_seniority_between5And10_men",
  "selfAssessment_staff_byDemographics_seniority_more10_women",
  "selfAssessment_staff_byDemographics_seniority_more10_men",
  "selfAssessment_staff_byDemographics_seniority_total_women",
  "selfAssessment_staff_byDemographics_seniority_total_men",
  "selfAssessment_staff_byDemographics_genderIdentity_womenMen_women",
  "selfAssessment_staff_byDemographics_genderIdentity_womenMen_men",
  "selfAssessment_staff_byDemographics_genderIdentity_transgenderMen_women",
  "selfAssessment_staff_byDemographics_genderIdentity_transgenderMen_men",
  "selfAssessment_staff_byDemographics_genderIdentity_transgenderWomen_women",
  "selfAssessment_staff_byDemographics_genderIdentity_transgenderWomen_men",
  "selfAssessment_staff_byDemographics_genderIdentity_genderNonConforming_women",
  "selfAssessment_staff_byDemographics_genderIdentity_genderNonConforming_men",
  "selfAssessment_staff_byDemographics_genderIdentity_other_women",
  "selfAssessment_staff_byDemographics_genderIdentity_other_men",
  "selfAssessment_staff_byDemographics_genderIdentity_other_description",
  "selfAssessment_staff_byDemographics_genderIdentity_total_women",
  "selfAssessment_staff_byDemographics_ethnicIdentity_asian_women",
  "selfAssessment_staff_byDemographics_ethnicIdentity_asian_men",
  "selfAssessment_staff_byDemographics_ethnicIdentity_hispanic_women",
  "selfAssessment_staff_byDemographics_ethnicIdentity_hispanic_men",
  "selfAssessment_staff_byDemographics_ethnicIdentity_other_women",
  "selfAssessment_staff_byDemographics_ethnicIdentity_other_men",
  "selfAssessment_staff_byDemographics_genderIdentity_total_men",
  "selfAssessment_staff_byDemographics_ethnicIdentity_otherCustom1",
  "selfAssessment_staff_byDemographics_ethnicIdentity_otherCustom2",
  "selfAssessment_staff_byDemographics_ethnicIdentity_otherCustom3",
  "selfAssessment_staff_byDemographics_ethnicIdentity_otherCustom4",
].concat(
  SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY_LEADERSHIP.women.fields,
  SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY_LEADERSHIP.men.fields,

  SELF_ASSESSMENT_FIELDS_STAFF_BY_DEPARTMENT.women.fields,
  SELF_ASSESSMENT_FIELDS_STAFF_BY_DEPARTMENT.men.fields,

  SELF_ASSESSMENT_FIELDS_STAFF_BOARD_OF_DIRECTORS.men.fields,
  SELF_ASSESSMENT_FIELDS_STAFF_BOARD_OF_DIRECTORS.women.fields,

  SELF_ASSESSMENT_FIELDS_BY_DEMOGRAPHIC_DISABILITIES.women.fields,
  SELF_ASSESSMENT_FIELDS_BY_DEMOGRAPHIC_DISABILITIES.men.fields,

  SELF_ASSESSMENT_FIELDS_BY_ETHNIC_IDENTITY.women.fields,
  SELF_ASSESSMENT_FIELDS_BY_ETHNIC_IDENTITY.men.fields
);

export const SELF_ASSESSMENT_HUMAN_RESOURCES_ABSENCES = {
  men: [
    "selfAssessment_humanResources_absences_totalWorkDays_men",
    "selfAssessment_humanResources_absences_totalLostDays_men",
    "selfAssessment_humanResources_absenceDueStoppage_men",
  ],
  women: [
    "selfAssessment_humanResources_absences_totalWorkDays_women",
    "selfAssessment_humanResources_absences_totalLostDays_women",
    "selfAssessment_humanResources_absenceDueStoppage_women",
  ],
};

export const SELF_ASSESSMENT_HUMAN_RETURNING_AFTER_MATERNITY_LEAVE = [
  "selfAssessment_humanResources_returningAfterMaternityLeave_took",
  "selfAssessment_humanResources_returningAfterMaternityLeave_didNotReturn",
  "selfAssessment_humanResources_returningAfterMaternityLeave_return",
];

export const SELF_ASSESSMENT_STAFFING = {
  women: [
    "selfAssessment_humanResources_staffing_applicants_women",
    "selfAssessment_humanResources_staffing_newHires_women",
  ],
  men: [
    "selfAssessment_humanResources_staffing_applicants_men",
    "selfAssessment_humanResources_staffing_newHires_men",
  ],
};

export const SELF_ASSESSMENT_INTERNAL_PROMOTIONS = {
  women: [
    "selfAssessment_humanResources_internalPromotions_nominated_women",
    "selfAssessment_humanResources_internalPromotions_promoted_women",
  ],
  men: [
    "selfAssessment_humanResources_internalPromotions_nominated_men",
    "selfAssessment_humanResources_internalPromotions_promoted_men",
  ],
};
export const SELF_ASSESSMENT_EDUCATION = {
  men: [
    "selfAssessment_humanResources_education_receivingTraining_women",
    "selfAssessment_humanResources_education_trainingHours_women",
  ],
  women: [
    "selfAssessment_humanResources_education_receivingTraining_men",
    "selfAssessment_humanResources_education_trainingHours_men",
  ],
};

export const SELF_ASSESSMENT_LABOR_CONDITIONS = [
  "selfAssessment_laborConditions_contract_full_subtotal_men",
  "selfAssessment_laborConditions_contract_full_subtotal_women",
  "selfAssessment_laborConditions_flexTime_elegible_NegotiatedShedule_men",
  "selfAssessment_laborConditions_flexTime_elegible_NegotiatedShedule_women",
  "selfAssessment_laborConditions_flexTime_elegible_childCareAtCompany_men",
  "selfAssessment_laborConditions_flexTime_elegible_childCareAtCompany_women",
  "selfAssessment_laborConditions_flexTime_elegible_externalChildCare_men",
  "selfAssessment_laborConditions_flexTime_elegible_externalChildCare_women",
  "selfAssessment_laborConditions_flexTime_elegible_flexibitilityArrivalDeparture_men",
  "selfAssessment_laborConditions_flexTime_elegible_flexibitilityArrivalDeparture_women",
  "selfAssessment_laborConditions_flexTime_elegible_paidLeave_men",
  "selfAssessment_laborConditions_flexTime_elegible_paidLeave_women",
  "selfAssessment_laborConditions_flexTime_elegible_reductionHours_men",
  "selfAssessment_laborConditions_flexTime_elegible_reductionHours_women",
  "selfAssessment_laborConditions_flexTime_elegible_telecommuting_men",
  "selfAssessment_laborConditions_flexTime_elegible_telecommuting_women",
  "selfAssessment_laborConditions_flexTime_elegible_total_men",
  "selfAssessment_laborConditions_flexTime_elegible_total_women",
  "selfAssessment_laborConditions_flexTime_elegible_transportationResidence_men",
  "selfAssessment_laborConditions_flexTime_elegible_transportationResidence_women",
  "selfAssessment_laborConditions_flexTime_elegible_unpaidLeave_men",
  "selfAssessment_laborConditions_flexTime_elegible_unpaidLeave_women",
  "selfAssessment_laborConditions_flexTime_other",
  "selfAssessment_laborConditions_flexTime_tookBenefit_NegotiatedShedule_men",
  "selfAssessment_laborConditions_flexTime_tookBenefit_NegotiatedShedule_women",
  "selfAssessment_laborConditions_flexTime_tookBenefit_childCareAtCompany_men",
  "selfAssessment_laborConditions_flexTime_tookBenefit_childCareAtCompany_women",
  "selfAssessment_laborConditions_flexTime_tookBenefit_externalChildCare_men",
  "selfAssessment_laborConditions_flexTime_tookBenefit_externalChildCare_women",
  "selfAssessment_laborConditions_flexTime_tookBenefit_flexibitilityArrivalDeparture_men",
  "selfAssessment_laborConditions_flexTime_tookBenefit_flexibitilityArrivalDeparture_women",
  "selfAssessment_laborConditions_flexTime_tookBenefit_paidLeave_men",
  "selfAssessment_laborConditions_flexTime_tookBenefit_paidLeave_women",
  "selfAssessment_laborConditions_flexTime_tookBenefit_reductionHours_men",
  "selfAssessment_laborConditions_flexTime_tookBenefit_reductionHours_women",
  "selfAssessment_laborConditions_flexTime_tookBenefit_telecommuting_men",
  "selfAssessment_laborConditions_flexTime_tookBenefit_telecommuting_women",
  "selfAssessment_laborConditions_flexTime_tookBenefit_total_men",
  "selfAssessment_laborConditions_flexTime_tookBenefit_total_women",
  "selfAssessment_laborConditions_flexTime_tookBenefit_transportationResidence_men",
  "selfAssessment_laborConditions_flexTime_tookBenefit_transportationResidence_women",
  "selfAssessment_laborConditions_flexTime_tookBenefit_unpaidLeave_men",
  "selfAssessment_laborConditions_flexTime_tookBenefit_unpaidLeave_women",
  "selfAssessment_laborConditions_leavePolicies_elegible_total_men",
  "selfAssessment_laborConditions_leavePolicies_elegible_total_women",
  "selfAssessment_laborConditions_leavePolicies_other",
  "selfAssessment_laborConditions_leavePolicies_tookBenefit_breastfeeding_women",
  "selfAssessment_laborConditions_leavePolicies_tookBenefit_maternity_women",
  "selfAssessment_laborConditions_leavePolicies_tookBenefit_paternity_men",
  "selfAssessment_laborConditions_leavePolicies_tookBenefit_permittedLeave_men",
  "selfAssessment_laborConditions_leavePolicies_tookBenefit_permittedLeave_women",
  "selfAssessment_laborConditions_leavePolicies_tookBenefit_reductionWorkingHours_men",
  "selfAssessment_laborConditions_leavePolicies_tookBenefit_reductionWorkingHours_women",
  "selfAssessment_laborConditions_leavePolicies_tookBenefit_total_men",
  "selfAssessment_laborConditions_leavePolicies_tookBenefit_total_women",
  "selfAssessment_laborConditions_preventingSexualHarassment_complaintsAddressed_men",
  "selfAssessment_laborConditions_preventingSexualHarassment_complaintsAddressed_women",
  "selfAssessment_laborConditions_preventingSexualHarassment_complaintsReceived_men",
  "selfAssessment_laborConditions_preventingSexualHarassment_complaintsReceived_women",
  "selfAssessment_laborConditions_preventingSexualHarassment_specificAttentionPromotion_men",
  "selfAssessment_laborConditions_preventingSexualHarassment_specificAttentionPromotion_women",
  "selfAssessment_laborConditions_preventingSexualHarassment_specificAttentionRecruitment_men",
  "selfAssessment_laborConditions_preventingSexualHarassment_specificAttentionRecruitment_women",
  "selfAssessment_laborConditions_preventingSexualHarassment_total_men",
  "selfAssessment_laborConditions_preventingSexualHarassment_total_women",
  "selfAssessment_laborConditions_flexTime_NegotiatedShedule_policyExists",
  "selfAssessment_laborConditions_flexTime_childCareAtCompany_policyExists",
  "selfAssessment_laborConditions_flexTime_externalChildCare_policyExists",
  "selfAssessment_laborConditions_flexTime_flexibitilityArrivalDeparture_policyExists",
  "selfAssessment_laborConditions_flexTime_paidLeave_policyExists",
  "selfAssessment_laborConditions_flexTime_reductionHours_policyExists",
  "selfAssessment_laborConditions_flexTime_telecommuting_policyExists",
  "selfAssessment_laborConditions_flexTime_transportationResidence_policyExists",
  "selfAssessment_laborConditions_flexTime_unpaidLeave_policyExists",
  "selfAssessment_laborConditions_leavePolicies_breastfeeding_policyExists",
  "selfAssessment_laborConditions_leavePolicies_maternity_policyExists",
  "selfAssessment_laborConditions_leavePolicies_paternity_policyExists",
  "selfAssessment_laborConditions_leavePolicies_permittedLeave_policyExists",
  "selfAssessment_laborConditions_leavePolicies_reductionWorkingHours_policyExists",
  "selfAssessment_staff_responsibility_total_women",
  "selfAssessment_staff_responsibility_total_men",
  "selfAssessment_humanResources_absences_annualDaysAgreed",
].concat(
  SELF_ASSESSMENT_LABOR_CONDITIONS_SEXUAL_HARASSMENT_RECEIVED.men.received
    .fields,
  SELF_ASSESSMENT_LABOR_CONDITIONS_SEXUAL_HARASSMENT_RECEIVED.men.received
    .total,

  SELF_ASSESSMENT_LABOR_CONDITIONS_SEXUAL_HARASSMENT_RECEIVED.men.resolved
    .fields,
  SELF_ASSESSMENT_LABOR_CONDITIONS_SEXUAL_HARASSMENT_RECEIVED.men.resolved
    .total,

  SELF_ASSESSMENT_LABOR_CONDITIONS_SEXUAL_HARASSMENT_RECEIVED.women.received
    .fields,
  SELF_ASSESSMENT_LABOR_CONDITIONS_SEXUAL_HARASSMENT_RECEIVED.women.received
    .total,

  SELF_ASSESSMENT_LABOR_CONDITIONS_SEXUAL_HARASSMENT_RECEIVED.women.resolved
    .fields,
  SELF_ASSESSMENT_LABOR_CONDITIONS_SEXUAL_HARASSMENT_RECEIVED.women.resolved
    .total,

  SELF_ASSESSMENT_LABOR_CONDITIONS_POSITION.men.fields,
  SELF_ASSESSMENT_LABOR_CONDITIONS_POSITION.men.total,

  SELF_ASSESSMENT_LABOR_CONDITIONS_POSITION.women.fields,
  SELF_ASSESSMENT_LABOR_CONDITIONS_POSITION.women.total,

  SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION.women.received.fields,
  SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION.women.received.total,

  SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION.men.received.fields,
  SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION.men.received.total,

  SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION.women.resolved.fields,
  SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION.women.resolved.total,

  SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION.men.resolved.fields,
  SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION.men.resolved.total,

  SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION_POSITION.men.fields,
  SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION_POSITION.men.total,

  SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION_POSITION.women.fields,
  SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION_POSITION.women.total,

  SELF_ASSESSMENT_HUMAN_RESOURCES_ABSENCES.men,
  SELF_ASSESSMENT_HUMAN_RESOURCES_ABSENCES.women,

  SELF_ASSESSMENT_STAFFING.men,
  SELF_ASSESSMENT_STAFFING.women,

  SELF_ASSESSMENT_INTERNAL_PROMOTIONS.men,
  SELF_ASSESSMENT_INTERNAL_PROMOTIONS.women,

  SELF_ASSESSMENT_EDUCATION.men,
  SELF_ASSESSMENT_EDUCATION.women,

  SELF_ASSESSMENT_LC_TYPE_OF_CONTRACT_FULL_TIME.men.fields,
  SELF_ASSESSMENT_LC_TYPE_OF_CONTRACT_FULL_TIME.women.fields,

  SELF_ASSESSMENT_LC_TYPE_OF_CONTRACT_PART_TIME.men.fields,
  SELF_ASSESSMENT_LC_TYPE_OF_CONTRACT_PART_TIME.men.subtotal,
  SELF_ASSESSMENT_LC_TYPE_OF_CONTRACT_PART_TIME.women.fields,
  SELF_ASSESSMENT_LC_TYPE_OF_CONTRACT_PART_TIME.women.subtotal,

  SELF_ASSESSMENT_LC_WAGES.men.fields,
  SELF_ASSESSMENT_LC_WAGES.women.fields,

  SELF_ASSESSMENT_LC_WORKING_PARENTS.men.fields,
  SELF_ASSESSMENT_LC_WORKING_PARENTS.women.fields,

  SELF_ASSESSMENT_LC_EXTENDED_LEAVE_POLICIES.men.receive.fields,
  SELF_ASSESSMENT_LC_EXTENDED_LEAVE_POLICIES.women.receive.fields,

  SELF_ASSESSMENT_GENERAL_INFORMATION
);
// Todos la información del estado se deben crear dentro de esta función,
// los otros modulos de vuex tienen la misma funcion
// Esto sirve para que cuando se cierre la sesión todos los elementos de vuex
// se pueden pasar a su estado inicial. Revisar función de cerrar sesión en userAccount

function initialState() {
  return {
    status: {
      assessment: "",
      snapshot: "",
    },
    optionListsStatus: "",
    optionLists: [],
    employmentPolicies: {},
    selfAssessment: {},
    // Este objeto de abajo es el que maneja toda la información del formulario
    // Al ser campos con nombres especificos no se pudo crear de forma más dinamica
    // Si se quiere agregar un campo nuevo, hay que ponerlo en este objeto para poderlo manejar despues
    selfAssessmentDefaultData: {
      selfAssessment_general_classification_sector: null,
      selfAssessment_general_classification_activityAggregated: null,
      selfAssessment_general_classification_activityDetailed: null,
      selfAssessment_general_classification_market_local: false,
      selfAssessment_general_classification_market_national: false,
      selfAssessment_general_classification_market_international: false,
      selfAssessment_general_size_numberEmployees: null,
      selfAssessment_general_size_revenue: null,
      selfAssessment_general_financialReturn_ebitda: null,
      selfAssessment_general_financialReturn_revenue: null,
      selfAssessment_general_financialReturn_netIncome: null,
      selfAssessment_general_financialReturn_roe: null,
      selfAssessment_general_financialReturn_roic: null,
      selfAssessment_general_financialReturn_rois: null,
      selfAssessment_general_business_wepsSignatory: null,
      selfAssessment_general_business_unGlobalCompactMember: null,
      selfAssessment_staff_responsibility_management_executiveDirector_women:
        null,
      selfAssessment_staff_responsibility_management_executiveDirector_men:
        null,
      selfAssessment_staff_responsibility_management_director_women: null,
      selfAssessment_staff_responsibility_management_director_men: null,
      selfAssessment_staff_responsibility_management_middleLevel4_women: null,
      selfAssessment_staff_responsibility_management_middleLevel4_men: null,
      selfAssessment_staff_responsibility_management_middleLevel3_women: null,
      selfAssessment_staff_responsibility_management_middleLevel3_men: null,
      selfAssessment_staff_responsibility_management_middleLevel2_women: null,
      selfAssessment_staff_responsibility_management_middleLevel2_men: null,
      selfAssessment_staff_responsibility_management_middleLevel1_women: null,
      selfAssessment_staff_responsibility_management_middleLevel1_men: null,
      selfAssessment_staff_responsibility_management_subtotal_women: null,
      selfAssessment_staff_responsibility_management_subtotal_men: null,
      selfAssessment_staff_responsibility_otherPositions_technical_women: null,
      selfAssessment_staff_responsibility_otherPositions_technical_men: null,
      selfAssessment_staff_responsibility_otherPositions_administrative_women:
        null,
      selfAssessment_staff_responsibility_otherPositions_administrative_men:
        null,
      selfAssessment_staff_responsibility_otherPositions_support_women: null,
      selfAssessment_staff_responsibility_otherPositions_suport_men: null,
      selfAssessment_staff_responsibility_otherPositions_operational_women:
        null,
      selfAssessment_staff_responsibility_otherPositions_operational_men: null,
      selfAssessment_staff_responsibility_otherPositions_subtotal_women: null,
      selfAssessment_staff_responsibility_otherPositions_subtotal_men: null,
      selfAssessment_staff_responsibility_total_women: null,
      selfAssessment_staff_responsibility_total_men: null,
      selfAssessment_staff_department_administration_women: null,
      selfAssessment_staff_department_administration_men: null,
      selfAssessment_staff_department_commercial_women: null,
      selfAssessment_staff_department_commercial_men: null,
      selfAssessment_staff_department_technical_women: null,
      selfAssessment_staff_department_technical_men: null,
      selfAssessment_staff_department_logistics_women: null,
      selfAssessment_staff_department_logistics_men: null,
      selfAssessment_staff_department_production_women: null,
      selfAssessment_staff_department_production_men: null,
      selfAssessment_staff_department_service_women: null,
      selfAssessment_staff_department_service_men: null,
      selfAssessment_staff_department_humanResources_women: null,
      selfAssessment_staff_department_humanResources_men: null,
      selfAssessment_staff_department_total_women: null,
      selfAssessment_staff_department_total_men: null,
      selfAssessment_staff_board_women: null,
      selfAssessment_staff_board_men: null,
      selfAssessment_staff_byDemographics_age_under18_women: null,
      selfAssessment_staff_byDemographics_age_under18_men: null,
      selfAssessment_staff_byDemographics_age_between18And30_women: null,
      selfAssessment_staff_byDemographics_age_between18And30_men: null,
      selfAssessment_staff_byDemographics_age_between31And60_women: null,
      selfAssessment_staff_byDemographics_age_between31And60_men: null,
      selfAssessment_staff_byDemographics_age_older60_women: null,
      selfAssessment_staff_byDemographics_age_older60_men: null,
      selfAssessment_staff_byDemographics_age_total_women: null,
      selfAssessment_staff_byDemographics_age_total_men: null,
      selfAssessment_staff_byDemographics_disability_yes_women: null,
      selfAssessment_staff_byDemographics_disability_yes_men: null,
      selfAssessment_staff_byDemographics_disability_no_women: null,
      selfAssessment_staff_byDemographics_disability_no_men: null,
      selfAssessment_staff_byDemographics_disability_total_women: null,
      selfAssessment_staff_byDemographics_disability_total_men: null,
      selfAssessment_staff_byDemographics_ethnicIdentity_white_women: null,
      selfAssessment_staff_byDemographics_ethnicIdentity_white_men: null,
      selfAssessment_staff_byDemographics_ethnicIdentity_afrodescendant_women:
        null,
      selfAssessment_staff_byDemographics_ethnicIdentity_afrodescendant_men:
        null,
      selfAssessment_staff_byDemographics_ethnicIdentity_indigenous_women: null,
      selfAssessment_staff_byDemographics_ethnicIdentity_indigenous_men: null,
      selfAssessment_staff_byDemographics_ethnicIdentity_nonAfroNonIndigenous_women:
        null,
      selfAssessment_staff_byDemographics_ethnicIdentity_nonAfroNonIndigenous_men:
        null,
      selfAssessment_staff_byDemographics_ethnicIdentity_afroAndIndigenous_women:
        null,
      selfAssessment_staff_byDemographics_ethnicIdentity_afroAndIndigenous_men:
        null,
      selfAssessment_staff_byDemographics_ethnicIdentity_total_women: null,
      selfAssessment_staff_byDemographics_ethnicIdentity_total_men: null,
      selfAssessment_staff_byDemographics_seniority_less2_women: null,
      selfAssessment_staff_byDemographics_seniority_less2_men: null,
      selfAssessment_staff_byDemographics_seniority_between2And5_women: null,
      selfAssessment_staff_byDemographics_seniority_between2And5_men: null,
      selfAssessment_staff_byDemographics_seniority_between5And10_women: null,
      selfAssessment_staff_byDemographics_seniority_between5And10_men: null,
      selfAssessment_staff_byDemographics_seniority_more10_women: null,
      selfAssessment_staff_byDemographics_seniority_more10_men: null,
      selfAssessment_staff_byDemographics_seniority_total_women: null,
      selfAssessment_staff_byDemographics_seniority_total_men: null,
      selfAssessment_staff_byDemographics_genderIdentity_women_women: null,
      selfAssessment_staff_byDemographics_genderIdentity_women_men: null,
      selfAssessment_staff_byDemographics_genderIdentity_men_women: null,
      selfAssessment_staff_byDemographics_genderIdentity_men_men: null,
      selfAssessment_staff_byDemographics_genderIdentity_transgenderMen_women:
        null,
      selfAssessment_staff_byDemographics_genderIdentity_transgenderMen_men:
        null,
      selfAssessment_staff_byDemographics_genderIdentity_transgenderWomen_women:
        null,
      selfAssessment_staff_byDemographics_genderIdentity_transgenderWomen_men:
        null,
      selfAssessment_staff_byDemographics_genderIdentity_genderNonConforming_women:
        null,
      selfAssessment_staff_byDemographics_genderIdentity_genderNonConforming_men:
        null,
      selfAssessment_staff_byDemographics_genderIdentity_other_women: null,
      selfAssessment_staff_byDemographics_genderIdentity_other_men: null,
      selfAssessment_staff_byDemographics_genderIdentity_other_description:
        null,
      selfAssessment_staff_byDemographics_genderIdentity_total_women: null,
      selfAssessment_staff_byDemographics_genderIdentity_total_men: null,
      selfAssessment_laborConditions_contract_full_permanent_women: null,
      selfAssessment_laborConditions_contract_full_permanent_men: null,
      selfAssessment_laborConditions_contract_full_temporary_women: null,
      selfAssessment_laborConditions_contract_full_temporary_men: null,
      selfAssessment_laborConditions_contract_full_subtotal_women: null,
      selfAssessment_laborConditions_contract_full_subtotal_men: null,
      selfAssessment_laborConditions_contract_part_permanent_women: null,
      selfAssessment_laborConditions_contract_part_permanent_men: null,
      selfAssessment_laborConditions_contract_part_temporary_women: null,
      selfAssessment_laborConditions_contract_part_temporary_men: null,
      selfAssessment_laborConditions_contract_part_subtotal_women: null,
      selfAssessment_laborConditions_contract_part_subtotal_men: null,
      selfAssessment_laborConditions_wages_executiveDirector_women: null,
      selfAssessment_laborConditions_wages_executiveDirector_men: null,
      selfAssessment_laborConditions_wages_management_women: null,
      selfAssessment_laborConditions_wages_management_men: null,
      selfAssessment_laborConditions_wages_middleLevel4_women: null,
      selfAssessment_laborConditions_wages_middleLevel4_men: null,
      selfAssessment_laborConditions_wages_middleLevel3_women: null,
      selfAssessment_laborConditions_wages_middleLevel3_men: null,
      selfAssessment_laborConditions_wages_middleLevel2_women: null,
      selfAssessment_laborConditions_wages_middleLevel2_men: null,
      selfAssessment_laborConditions_wages_middleLevel1_women: null,
      selfAssessment_laborConditions_wages_middleLevel1_men: null,
      selfAssessment_laborConditions_wages_technical_women: null,
      selfAssessment_laborConditions_wages_technical_men: null,
      selfAssessment_laborConditions_wages_administrative_women: null,
      selfAssessment_laborConditions_wages_administrative_men: null,
      selfAssessment_laborConditions_wages_support_women: null,
      selfAssessment_laborConditions_wages_support_men: null,
      selfAssessment_laborConditions_wages_operational_women: null,
      selfAssessment_laborConditions_wages_operational_men: null,
      selfAssessment_laborConditions_leavePolicies_elegible_paternity_men: null,
      selfAssessment_laborConditions_leavePolicies_tookBenefit_paternity_men:
        null,
      selfAssessment_laborConditions_leavePolicies_paternity_policyExists: false,
      selfAssessment_laborConditions_leavePolicies_elegible_maternity_women:
        null,
      selfAssessment_laborConditions_leavePolicies_tookBenefit_maternity_women:
        null,
      selfAssessment_laborConditions_leavePolicies_maternity_policyExists: false,
      selfAssessment_laborConditions_leavePolicies_elegible_breastfeeding_women:
        null,
      selfAssessment_laborConditions_leavePolicies_tookBenefit_breastfeeding_women:
        null,
      selfAssessment_laborConditions_leavePolicies_breastfeeding_policyExists: false,
      selfAssessment_laborConditions_leavePolicies_elegible_reductionWorkingHours_women:
        null,
      selfAssessment_laborConditions_leavePolicies_elegible_reductionWorkingHours_men:
        null,
      selfAssessment_laborConditions_leavePolicies_tookBenefit_reductionWorkingHours_women:
        null,
      selfAssessment_laborConditions_leavePolicies_tookBenefit_reductionWorkingHours_men:
        null,
      selfAssessment_laborConditions_leavePolicies_reductionWorkingHours_policyExists: false,
      selfAssessment_laborConditions_leavePolicies_elegible_permittedLeave_women:
        null,
      selfAssessment_laborConditions_leavePolicies_elegible_permittedLeave_men:
        null,
      selfAssessment_laborConditions_leavePolicies_tookBenefit_permittedLeave_women:
        null,
      selfAssessment_laborConditions_leavePolicies_tookBenefit_permittedLeave_men:
        null,
      selfAssessment_laborConditions_leavePolicies_permittedLeave_policyExists: false,
      selfAssessment_laborConditions_leavePolicies_other: null,
      selfAssessment_laborConditions_leavePolicies_elegible_total_women: null,
      selfAssessment_laborConditions_leavePolicies_elegible_total_men: null,
      selfAssessment_laborConditions_leavePolicies_tookBenefit_total_women:
        null,
      selfAssessment_laborConditions_leavePolicies_tookBenefit_total_men: null,
      selfAssessment_laborConditions_flexTime_elegible_flexibitilityArrivalDeparture_women:
        null,
      selfAssessment_laborConditions_flexTime_elegible_flexibitilityArrivalDeparture_men:
        null,
      selfAssessment_laborConditions_flexTime_tookBenefit_flexibitilityArrivalDeparture_women:
        null,
      selfAssessment_laborConditions_flexTime_tookBenefit_flexibitilityArrivalDeparture_men:
        null,
      selfAssessment_laborConditions_flexTime_flexibitilityArrivalDeparture_policyExists: false,
      selfAssessment_laborConditions_flexTime_elegible_NegotiatedShedule_women:
        null,
      selfAssessment_laborConditions_flexTime_elegible_NegotiatedShedule_men:
        null,
      selfAssessment_laborConditions_flexTime_tookBenefit_NegotiatedShedule_women:
        null,
      selfAssessment_laborConditions_flexTime_tookBenefit_NegotiatedShedule_men:
        null,
      selfAssessment_laborConditions_flexTime_NegotiatedShedule_policyExists: false,
      selfAssessment_laborConditions_flexTime_elegible_reductionHours_women:
        null,
      selfAssessment_laborConditions_flexTime_elegible_reductionHours_men: null,
      selfAssessment_laborConditions_flexTime_tookBenefit_reductionHours_women:
        null,
      selfAssessment_laborConditions_flexTime_tookBenefit_reductionHours_men:
        null,
      selfAssessment_laborConditions_flexTime_reductionHours_policyExists: false,
      selfAssessment_laborConditions_flexTime_elegible_paidLeave_women: null,
      selfAssessment_laborConditions_flexTime_elegible_paidLeave_men: null,
      selfAssessment_laborConditions_flexTime_tookBenefit_paidLeave_women: null,
      selfAssessment_laborConditions_flexTime_tookBenefit_paidLeave_men: null,
      selfAssessment_laborConditions_flexTime_paidLeave_policyExists: false,
      selfAssessment_laborConditions_flexTime_elegible_unpaidLeave_women: null,
      selfAssessment_laborConditions_flexTime_elegible_unpaidLeave_men: null,
      selfAssessment_laborConditions_flexTime_tookBenefit_unpaidLeave_women:
        null,
      selfAssessment_laborConditions_flexTime_tookBenefit_unpaidLeave_men: null,
      selfAssessment_laborConditions_flexTime_unpaidLeave_policyExists: false,
      selfAssessment_laborConditions_flexTime_elegible_telecommuting_women:
        null,
      selfAssessment_laborConditions_flexTime_elegible_telecommuting_men: null,
      selfAssessment_laborConditions_flexTime_tookBenefit_telecommuting_women:
        null,
      selfAssessment_laborConditions_flexTime_tookBenefit_telecommuting_men:
        null,
      selfAssessment_laborConditions_flexTime_telecommuting_policyExists: false,
      selfAssessment_laborConditions_flexTime_elegible_transportationResidence_women:
        null,
      selfAssessment_laborConditions_flexTime_elegible_transportationResidence_men:
        null,
      selfAssessment_laborConditions_flexTime_tookBenefit_transportationResidence_women:
        null,
      selfAssessment_laborConditions_flexTime_tookBenefit_transportationResidence_men:
        null,
      selfAssessment_laborConditions_flexTime_transportationResidence_policyExists: false,
      selfAssessment_laborConditions_flexTime_elegible_childCareAtCompany_women:
        null,
      selfAssessment_laborConditions_flexTime_elegible_childCareAtCompany_men:
        null,
      selfAssessment_laborConditions_flexTime_tookBenefit_childCareAtCompany_women:
        null,
      selfAssessment_laborConditions_flexTime_tookBenefit_childCareAtCompany_men:
        null,
      selfAssessment_laborConditions_flexTime_childCareAtCompany_policyExists: false,
      selfAssessment_laborConditions_flexTime_elegible_externalChildCare_women:
        null,
      selfAssessment_laborConditions_flexTime_elegible_externalChildCare_men:
        null,
      selfAssessment_laborConditions_flexTime_tookBenefit_externalChildCare_women:
        null,
      selfAssessment_laborConditions_flexTime_tookBenefit_externalChildCare_men:
        null,
      selfAssessment_laborConditions_flexTime_externalChildCare_policyExists: false,
      selfAssessment_laborConditions_flexTime_other: null,
      selfAssessment_laborConditions_flexTime_elegible_total_women: null,
      selfAssessment_laborConditions_flexTime_elegible_total_men: null,
      selfAssessment_laborConditions_flexTime_tookBenefit_total_women: null,
      selfAssessment_laborConditions_flexTime_tookBenefit_total_men: null,
      selfAssessment_laborConditions_preventingSexualHarassment_complaintsReceived_women:
        null,
      selfAssessment_laborConditions_preventingSexualHarassment_complaintsReceived_men:
        null,
      selfAssessment_laborConditions_preventingSexualHarassment_complaintsAddressed_women:
        null,
      selfAssessment_laborConditions_preventingSexualHarassment_complaintsAddressed_men:
        null,
      selfAssessment_laborConditions_preventingSexualHarassment_specificAttentionRecruitment_women:
        null,
      selfAssessment_laborConditions_preventingSexualHarassment_specificAttentionRecruitment_men:
        null,
      selfAssessment_laborConditions_preventingSexualHarassment_specificAttentionPromotion_women:
        null,
      selfAssessment_laborConditions_preventingSexualHarassment_specificAttentionPromotion_men:
        null,
      selfAssessment_laborConditions_preventingSexualHarassment_total_women:
        null,
      selfAssessment_laborConditions_preventingSexualHarassment_total_men: null,
      selfAssessment_humanResources_absences_annualDaysAgreed: null,
      selfAssessment_humanResources_totalPeopleStaff_women: null,
      selfAssessment_humanResources_totalPeopleStaff_men: null,
      selfAssessment_humanResources_absences_totalWorkDays_women: null,
      selfAssessment_humanResources_absences_totalWorkDays_men: null,
      selfAssessment_humanResources_absences_totalLostDays_women: null,
      selfAssessment_humanResources_absences_totalLostDays_men: null,
      selfAssessment_humanResources_totalStaff_women: null,
      selfAssessment_humanResources_totalStaff_men: null,
      selfAssessment_humanResources_absenceDueStoppage_women: null,
      selfAssessment_humanResources_absenceDueStoppage_men: null,
      selfAssessment_humanResources_returningAfterMaternityLeave_took: null,
      selfAssessment_humanResources_returningAfterMaternityLeave_didNotReturn:
        null,
      selfAssessment_humanResources_returningAfterMaternityLeave_return: null,
      selfAssessment_humanResources_staffing_applicants_women: null,
      selfAssessment_humanResources_staffing_applicants_men: null,
      selfAssessment_humanResources_staffing_newHires_women: null,
      selfAssessment_humanResources_staffing_newHires_men: null,
      selfAssessment_humanResources_internalPromotions_nominated_women: null,
      selfAssessment_humanResources_internalPromotions_nominated_men: null,
      selfAssessment_humanResources_internalPromotions_promoted_women: null,
      selfAssessment_humanResources_internalPromotions_promoted_men: null,
      selfAssessment_humanResources_totalNumberStaff_women: null,
      selfAssessment_humanResources_totalNumberStaff_men: null,
      selfAssessment_humanResources_education_receivingTraining_women: null,
      selfAssessment_humanResources_education_receivingTraining_men: null,
      selfAssessment_humanResources_education_trainingHours_women: null,
      selfAssessment_humanResources_education_trainingHours_men: null,
      selfAssessment_employmentPolicies_internalCommunication_q1_inclusiveLanguage:
        null,
      selfAssessment_employmentPolicies_internalCommunication_q2_accesibility:
        null,
      selfAssessment_employmentPolicies_internalCommunication_q3_commitment:
        null,
      selfAssessment_employmentPolicies_internalCommunication_q4_criteriaOfEquality:
        null,
      selfAssessment_employmentPolicies_externalCommunication_q5_inclusiveLanguage:
        null,
      selfAssessment_employmentPolicies_externalCommunication_q6_commitment:
        null,
      selfAssessment_employmentPolicies_externalCommunication_q7_nontraditionalGenderRoles:
        null,
      selfAssessment_employmentPolicies_externalCommunication_q8_criteriaOfEquality:
        null,
      selfAssessment_employmentPolicies_recruitment_q9_promotion: null,
      selfAssessment_employmentPolicies_recruitment_q10_aimForWomenToBalance:
        null,
      selfAssessment_employmentPolicies_recruitment_q11_inclusiveLanguage: null,
      selfAssessment_employmentPolicies_recruitment_q12_formalProcess: null,
      selfAssessment_employmentPolicies_recruitment_q13_jobsReservedforWomen:
        null,
      selfAssessment_employmentPolicies_recruitment_q14_jobsReservedforMen:
        null,
      selfAssessment_employmentPolicies_recruitment_q15_equalOpportunities:
        null,
      selfAssessment_employmentPolicies_recruitment_q16_prohibitDiscrimination:
        null,
      selfAssessment_employmentPolicies_recruitment_q17_processEqualForMenWomen:
        null,
      selfAssessment_employmentPolicies_promotion_q18_fairAssessments: null,
      selfAssessment_employmentPolicies_promotion_q19_PromotionWithoutGenderBias:
        null,
      selfAssessment_employmentPolicies_promotion_q20_internalPolicy: null,
      selfAssessment_employmentPolicies_promotion_q21_concreteObjectivesMobility:
        null,
      selfAssessment_employmentPolicies_promotion_q22_EnsureMenWomenAccessPromotions:
        null,
      selfAssessment_employmentPolicies_promotion_q23_EnsureEqualRepresentation:
        null,
      selfAssessment_employmentPolicies_promotion_q24_careerPaths: null,
      selfAssessment_employmentPolicies_promotion_q25_criteriaOfEquality: null,
      selfAssessment_employmentPolicies_training_q26_consistencyWithNeedsIdentified:
        null,
      selfAssessment_employmentPolicies_training_q27_specificObjectivesOnGenderEquity:
        null,
      selfAssessment_employmentPolicies_training_q28_EnsureMenWomenAccessTraining:
        null,
      selfAssessment_employmentPolicies_training_q29_verficationOfTraining:
        null,
      selfAssessment_employmentPolicies_training_q30_accessForNontraditionalPositions:
        null,
      selfAssessment_employmentPolicies_training_q31_interferenceWithFamily:
        null,
      selfAssessment_employmentPolicies_training_q32_annualTrainings: null,
      selfAssessment_employmentPolicies_training_q33_criteriaOfEquality: null,
      selfAssessment_employmentPolicies_wages_q34_ensureEqualPay: null,
      selfAssessment_employmentPolicies_wages_q35_transparentInformation: null,
      selfAssessment_employmentPolicies_wages_q36_implementationOfEqualPay:
        null,
      selfAssessment_employmentPolicies_wages_q37_criteriaForAssigningSalary:
        null,
      selfAssessment_employmentPolicies_wages_q38_fairWagePolicy: null,
      selfAssessment_employmentPolicies_preventionSexualHarassment_q39_informationExplicitProhibition:
        null,
      selfAssessment_employmentPolicies_preventionSexualHarassment_q40_institutionalPolicy:
        null,
      selfAssessment_employmentPolicies_preventionSexualHarassment_q41_annualTraining:
        null,
      selfAssessment_employmentPolicies_preventionSexualHarassment_q42_responsiblesForMeasures:
        null,
      selfAssessment_employmentPolicies_preventionSexualHarassment_q43_monitoringAndFollowing:
        null,
      selfAssessment_employmentPolicies_preventionSexualHarassment_q44_awareness:
        null,
      selfAssessment_employmentPolicies_preventionSexualHarassment_q45_documentedProcedures:
        null,
      selfAssessment_employmentPolicies_preventionSexualHarassment_q46_trackOfComplaints:
        null,
      selfAssessment_employmentPolicies_preventionSexualHarassment_q47_annualAwareness:
        null,
      selfAssessment_employmentPolicies_preventionSexualHarassment_q48_staffAwareness:
        null,
      selfAssessment_employmentPolicies_preventionSexualHarassment_q49_mechanismEffectiveness:
        null,
      selfAssessment_employmentPolicies_wlbs_q50_womanQuitJobDueBirthOrFamily:
        null,
      selfAssessment_employmentPolicies_wlbs_q51_benefitsOfMaternity: null,
      selfAssessment_employmentPolicies_wlbs_q52_workersFamilyAndPersonalNeeds:
        null,
      selfAssessment_employmentPolicies_wlbs_q53_promotionOfCoparenting: null,
      selfAssessment_employmentPolicies_wlbs_q54_supportForCareServicesChildrenOthers:
        null,
      selfAssessment_employmentPolicies_wlbs_q55_flexibleWorking: null,
      selfAssessment_employmentPolicies_wlbs_q56_worklifeBalance: null,
      selfAssessment_employmentPolicies_wlbs_q57_absencesWithinWorkingHours:
        null,
      selfAssessment_employmentPolicies_wlbs_q58_worklifeBalancePolicies: null,
      selfAssessment_employmentPolicies_wlbs_q59_staffAwarenessWorklifeMeasures:
        null,
      selfAssessment_staff_byDemographics_ethnicIdentity_asian_women: null,
      selfAssessment_staff_byDemographics_ethnicIdentity_asian_men: null,
      selfAssessment_staff_byDemographics_ethnicIdentity_hispanic_women: null,
      selfAssessment_staff_byDemographics_ethnicIdentity_hispanic_men: null,
      selfAssessment_staff_byDemographics_ethnicIdentity_other_women: null,
      selfAssessment_staff_byDemographics_ethnicIdentity_other_men: null,
    },
    score: {},
  };
}

const state = initialState;

const getters = {
  getSelfAssessmentScore: (state) => (category) => {
    if (state.score && state.score[category]?.score){
      return Math.floor(state.score[category]?.score);
    }
    return 0;
  },
  getSelfAssessment: (state) => state.selfAssessment,
  getReloadSelfAssessment: (state) => {
    return state.reloadSelfAssessment;
  },
  getSelfAssessmentStatus: (state) => state.status,
  getSelfAssessmentField: (state) => {
    return getField(state.selfAssessment);
  },
  getOptionLists: (state) => state.optionLists,
  getOptionListByName: (state) => (optionListName) => {
    return state.optionLists.find((x) => x.name === optionListName).itemLists;
  },
  getEmploymentPolicies: (state) => state.employmentPolicies,
  getPercentage: () => (answers, totalFields) => {
    if (isNaN(parseInt(totalFields)) || totalFields <= 0) {
      return 0;
    }
    const percentage = parseInt((answers / totalFields) * 100);
    if (percentage > 100) {
      return 100;
    }
    return percentage;
  },
  getTotals: (state) => (correspondingFields) => {
    let total = 0;
    for (const field of correspondingFields) {
      if (state.selfAssessment[field] > 0) {
        total += state.selfAssessment[field];
      }
    }
    return total;
  },
  getBaseConstantFromDescription: () => (baseVariable) => {
    let baseConstant = null;
    if (
      baseVariable === "SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY_LEADERSHIP"
    ) {
      baseConstant = SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY_LEADERSHIP;
    }

    if (
      baseVariable ===
      "SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY_OTHER_POSITIONS"
    ) {
      baseConstant =
        SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY_OTHER_POSITIONS;
    }

    if (baseVariable === "SELF_ASSESSMENT_FIELDS_STAFF_BY_DEPARTMENT") {
      baseConstant = SELF_ASSESSMENT_FIELDS_STAFF_BY_DEPARTMENT;
    }

    if (baseVariable === "SELF_ASSESSMENT_FIELDS_STAFF_BOARD_OF_DIRECTORS") {
      baseConstant = SELF_ASSESSMENT_FIELDS_STAFF_BOARD_OF_DIRECTORS;
    }

    if (baseVariable === "SELF_ASSESSMENT_FIELDS_BY_DEMOGRAPHICS_AGE") {
      baseConstant = SELF_ASSESSMENT_FIELDS_BY_DEMOGRAPHICS_AGE;
    }

    if (baseVariable === "SELF_ASSESSMENT_FIELDS_BY_DEMOGRAPHIC_DISABILITIES") {
      baseConstant = SELF_ASSESSMENT_FIELDS_BY_DEMOGRAPHIC_DISABILITIES;
    }

    if (baseVariable === "SELF_ASSESSMENT_FIELDS_BY_ETHNIC_IDENTITY") {
      baseConstant = SELF_ASSESSMENT_FIELDS_BY_ETHNIC_IDENTITY;
    }

    if (baseVariable === "SELF_ASSESSMENT_FIELDS_BY_ETHNIC_SENIORITY") {
      baseConstant = SELF_ASSESSMENT_FIELDS_BY_ETHNIC_SENIORITY;
    }

    if (baseVariable === "SELF_ASSESSMENT_FIELDS_BY_GENDER_IDENTITY") {
      baseConstant = SELF_ASSESSMENT_FIELDS_BY_GENDER_IDENTITY;
    }

    if (baseVariable === "SELF_ASSESSMENT_LC_TYPE_OF_CONTRACT_FULL_TIME") {
      baseConstant = SELF_ASSESSMENT_LC_TYPE_OF_CONTRACT_FULL_TIME;
    }

    if (baseVariable === "SELF_ASSESSMENT_LC_TYPE_OF_CONTRACT_PART_TIME") {
      baseConstant = SELF_ASSESSMENT_LC_TYPE_OF_CONTRACT_PART_TIME;
    }

    if (baseVariable === "SELF_ASSESSMENT_LC_WAGES") {
      baseConstant = SELF_ASSESSMENT_LC_WAGES;
    }

    if (baseVariable === "SELF_ASSESSMENT_LC_WORKING_PARENTS") {
      baseConstant = SELF_ASSESSMENT_LC_WORKING_PARENTS;
    }

    if (baseVariable === "SELF_ASSESSMENT_LC_EXTENDED_LEAVE_POLICIES") {
      baseConstant = SELF_ASSESSMENT_LC_EXTENDED_LEAVE_POLICIES;
    }

    if (
      baseVariable ===
      "SELF_ASSESSMENT_LABOR_CONDITIONS_SEXUAL_HARASSMENT_RECEIVED"
    ) {
      baseConstant =
        SELF_ASSESSMENT_LABOR_CONDITIONS_SEXUAL_HARASSMENT_RECEIVED;
    }

    if (baseVariable === "SELF_ASSESSMENT_LABOR_CONDITIONS_POSITION") {
      baseConstant = SELF_ASSESSMENT_LABOR_CONDITIONS_POSITION;
    }

    if (
      baseVariable ===
      "SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION_POSITION"
    ) {
      baseConstant =
        SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION_POSITION;
    }

    return baseConstant;
  },
};

const actions = {
  // Hacemos la consulta de la información del assessment teniendo en cuenta la compñia y el snapshot
  // Con esto almacenamos toda la información necesaria que se va usar en toda la aplicación
  SELF_ASSESSMENT_GET: ({ commit, dispatch, state, rootState }) => {
    return new Promise((resolve, reject) => {
      commit("setAssessmentStatus", { status: "pending", key: "assessment" });
      const companyId = rootState.business.currentBusiness.id;
      const snapshotId = rootState.business.currentSnapshot.snapshotId;
      axiosCall({
        url: "SelfAssessments/get/" + companyId + "/?snapshot=" + snapshotId,
      })
        .then((resp) => {
          commit("setAssessmentStatus", {
            status: "success",
            key: "assessment",
          });
          if (resp.data.selfAssessment) {
            console.log("usar resp.data.selfAssessment......");
            commit("setSelfAssessment", resp.data.selfAssessment);
            dispatch("SET_DEFAULT_SELF_ASSESSMENT_FIELDS_GENERAL_INFORMATION");
            dispatch("SET_DEFAULT_SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY");
            dispatch("SET_DEFAULT_SELF_ASSESSMENT_LABOR_CONDITIONS");
            commit("organizeEmploymentPolicies");
            commit("setAssessmentScore", resp.data.selfAssessment.selfAssessment_score);
          } else {
            var tempSelfAssessment = state.selfAssessmentDefaultData;
            tempSelfAssessment.snapshotId = snapshotId;
            dispatch("SELF_ASSESSMENT_INITIAL_VALUES", tempSelfAssessment)
              // dispatch('SELF_ASSESSMENT_UPDATE', tempSelfAssessment)
              .then(() => {
                commit("setSelfAssessment", tempSelfAssessment);
              })
              .catch((err) => {
                console.log(err);
              });
          }
          // dispatch('OPTION_LIST_GET')

          resolve(resp);
        })
        .catch((err) => {
          commit("setAssessmentStatus", { status: "error", key: "assessment" });
          reject(err);
        });
    });
  },
  SELF_ASSESSMENT_UPDATE: ({ commit, rootState }, data) => {
    commit("setAssessmentStatus", { status: "pending", key: "assessment" });
    const companyId = rootState.business.currentBusiness.id;
    const snapshotId = rootState.business.currentSnapshot.snapshotId;
    data.snapshotId = snapshotId;

    if (
      rootState.business.currentSnapshot.status ===
      "label_configuration_snapshot_validation"
    ) {
      return;
    }
    axiosCall({
      url: "SelfAssessments/save/" + companyId,
      method: "POST",
      data: data,
    }) // TODO Change name for id as url filter
      .then((selfAssessment) => {
        commit("setAssessmentScore", selfAssessment.data.selfAssessment_score);
        commit("setAssessmentStatus", { status: "success", key: "assessment" });
      })
      .catch((err) => {
        console.log(err);
        commit("setAssessmentStatus", { status: "error", key: "assessment" });
      });
  },
  SELF_SNAPSHOT_SEND_TO_VALIDATE: ({ commit, rootState }) => {
    return new Promise((resolve, reject) => {
      commit("setAssessmentStatus", { status: "pending", key: "snapshot" });
      const snapshotId = rootState.business.currentSnapshot.snapshotId;
      axiosCall({ url: "Snapshots/" + snapshotId })
        .then((resp) => {
          commit("setAssessmentStatus", { status: "success", key: "snapshot" });
          var snapshot = resp.data;
          snapshot.status = "label_configuration_snapshot_validation";
          snapshot.endDate = new Date().toString();
          axiosCall({
            url: "Snapshots/" + snapshotId,
            method: "PUT",
            data: snapshot,
          })
            .then((resp) => {
              commit("setAssessmentStatus", {
                status: "success",
                key: "snapshot",
              });
              commit(
                "updateCurrentSnapshot",
                "label_configuration_snapshot_validation"
              );
              resolve(resp);
            })
            .catch((err) => {
              commit("setAssessmentStatus", {
                status: "error",
                key: "snapshot",
              });
              reject(err);
            });
        })
        .catch((err) => {
          commit("setAssessmentStatus", { status: "error", key: "snapshot" });
          reject(err);
        });
    });
  },
  OPTION_LIST_GET: ({ commit, state }) => {
    if (state.optionListsStatus !== "success") {
      return new Promise((resolve, reject) => {
        commit("OPTION_LIST_REQUEST");
        axiosCall({ url: "OptionLists" })
          .then((resp) => {
            commit("OPTION_LIST_SUCCESS");
            commit("setOptionList", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            commit("OPTION_LIST_ERROR");
            reject(err);
          });
      });
    }
  },
  SET_DEFAULT_SELF_ASSESSMENT_FIELDS_GENERAL_INFORMATION: ({ dispatch }) => {
    dispatch(
      "SET_DEFAULT_SELF_ASSESSMENT_FIELDS",
      SELF_ASSESSMENT_GENERAL_INFORMATION
    );
  },
  SET_DEFAULT_SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY: ({ dispatch }) => {
    dispatch(
      "SET_DEFAULT_SELF_ASSESSMENT_FIELDS",
      SELF_ASSESSMENT_FIELDS_STAFF_RESPONSABILITY
    );
  },
  SET_DEFAULT_SELF_ASSESSMENT_LABOR_CONDITIONS: ({ dispatch }) => {
    dispatch(
      "SET_DEFAULT_SELF_ASSESSMENT_FIELDS",
      SELF_ASSESSMENT_LABOR_CONDITIONS
    );
  },
  SELF_ASSESSMENT_INITIAL_VALUES: () => {
    this.state.selfAssessmentDefaultData = Object.assign(
      this.state.selfAssessment,
      this.state.selfAssessmentDefaultData
    );
  },
  SET_DEFAULT_SELF_ASSESSMENT_FIELDS: ({ commit }, fieldsToSet) => {
    for (const field of fieldsToSet) {
      commit("setSelfAssessmentField", field);
    }
  },
};

const mutations = {
  setAssessmentScore: (state, data) => {
    state.score = data;
  },
  setAssessmentStatus: (state, data) => {
    state.status[data.key] = data.status;
  },
  setReloadSelfAssessment: (state, data) => {
    state.reloadSelfAssessment = data;
  },
  setSelfAssessment: (state, resp) => {
    Vue.set(state, "selfAssessment", resp);
  },
  setSelfAssessmentField: (state, field) => {
    if (
      state.selfAssessment[field] == null ||
      state.selfAssessment[field] === undefined
    ) {
      Vue.set(state.selfAssessment, field, DEFAULT_SELF_ASSESSMENT_VALUE);
    }
  },
  setSelfAssessmentData: (state, data) => {
    state.selfAssessment[data.field] = data.value;
  },
  updateSelfAssessmentField: (state, field) => {
    updateField(state.selfAssessment, field);
  },
  OPTION_LIST_REQUEST: (state) => {
    state.optionListsStatus = "loading";
  },
  OPTION_LIST_SUCCESS: (state) => {
    state.optionListsStatus = "success";
  },
  OPTION_LIST_ERROR: (state) => {
    state.optionListsStatus = "error";
  },
  setOptionList: (state, resp) => {
    Vue.set(state, "optionLists", resp);
  },
  setEmploymentPolicies: (state, setEmploymentPolicies) => {
    state.employmentPolicies = setEmploymentPolicies;
  },
  organizeEmploymentPolicies: (state) => {
    // Esta función me permite agrugar todas las employmentPolicies por categorias
    // para poderlas renderizar más facilmente más adelante.
    state.employmentPolicies = {
      selfAssessment_employmentPolicies_internalCommunication: {
        questions: [],
      },
      selfAssessment_employmentPolicies_externalCommunication: {
        questions: [],
      },
      selfAssessment_employmentPolicies_recruitment: {
        questions: [],
      },
      selfAssessment_employmentPolicies_promotion: {
        questions: [],
      },
      selfAssessment_employmentPolicies_training: {
        questions: [],
      },
      selfAssessment_employmentPolicies_wages: {
        questions: [],
      },
      selfAssessment_employmentPolicies_preventionSexualHarassment: {
        questions: [],
      },
      selfAssessment_employmentPolicies_wlbs: {
        questions: [],
      },
    };

    for (var ep in state.employmentPolicies) {
      for (var i in state.selfAssessment) {
        if (i.substring(0, ep.length) === ep) {
          var question = i.split(ep + "_")[1];
          var number = "label_" + ep + "_" + question.split("_")[0] + "_number";
          var field = i;
          state.employmentPolicies[ep].questions.push({
            question,
            number,
            field,
            answer: state.selfAssessment[field],
          });
        }
      }
    }

    state.employmentPolicies["internalExternalCommunication"] = {
      questions: state.employmentPolicies[
        "selfAssessment_employmentPolicies_internalCommunication"
      ].questions.concat(
        state.employmentPolicies[
          "selfAssessment_employmentPolicies_externalCommunication"
        ].questions
      ),
    };
  },
  SelfAssessmentReset: (state) => {
    const s = initialState();
    Object.keys(s).forEach((key) => {
      state[key] = s[key];
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
